<template>
  <div class="homeBox" v-show="showStatus" style="display: none;">
    <Header :colorType='colorType' :pageType='pageType' :productType='productType' class="header"></Header>
    <div class="content">
      <div class="top">
        <div class="top_left">
          <img src="../../assets/product/product/p2_1.png" class="img_big" v-if="active==1"/>
          <img src="../../assets/product/product/p2_2.png" class="img_big" v-if="active==2"/>
          <img src="../../assets/product/product/p2_3.png" class="img_big" v-if="active==3"/>
          <img src="../../assets/product/product/p2_4.png" class="img_big" v-if="active==4"/>
          <div class="img_box">
            <div class="img_icon_box">
              <img src="../../assets/plan/left.png" class="img_icon" @click="reduce(4)"/>
            </div>
            <div class="img_small_box">
              <img src="../../assets/product/product/p2_1.png" :class="['img_small', active==1?'img_small_active' : ''] " @click="changeImg(1)"/>
              <img src="../../assets/product/product/p2_2.png" :class="['img_small', active==2?'img_small_active' : ''] " @click="changeImg(2)"/>
              <img src="../../assets/product/product/p2_3.png" :class="['img_small', active==3?'img_small_active' : ''] " @click="changeImg(3)"/>
              <img src="../../assets/product/product/p2_4.png" :class="['img_small', active==4?'img_small_active' : ''] " @click="changeImg(4)"/>
            </div>
            <div class="img_icon_box">
              <img src="../../assets/plan/right.png" class="img_icon" @click="add(4)"/>
            </div>
          </div>
        </div>
        <div class="top_right">
          <h3>任马停-车道监控</h3>
          <h4>RMT-400-JK</h4>
          <h5>￥11,296<span>/套</span></h5>
          <p>包含8个400万像素枪式摄像机配套1台16路硬盘录像机、1块8T硬盘、1台24寸监控显示器及交换机、电控箱、电源、机房空调等配套设备。</p>
          <div class="link" @click="link">查看智能停车收费控制机产品详情>></div>
        </div>
      </div>
      <div class="introduce">
        <h3>产品介绍</h3>
        <p>
          枪式摄像机：像素：400万<br>
          补光距离：最远可达30 m<br>
          红外波长范围：850 nm<br>
          防补光过曝：支持<br>
          日夜切换模式：ICR红外滤片式<br>
          音频：1个内置麦克风<br>
          网络：1个RJ45 10 M/100 M 自适应以太网口<br>
          硬盘录像机：<br>
          视频接入路数：16路<br>
          网络输入带宽：160Mbps<br>
          视频输出：1路HDMI ，1路VGA<br>
          预览分屏：1/2/4/6/8/9/16画面<br>
          同步回放：16<br>
          录像/抓图模式：手动录像、定时录像、事件录像、移动侦测录像、报警录像、动测或报警录像、动测且报警录像回放模式：即时回放、常规回放、事件回放、标签回放、智能回放、外部文件回放、日志回放
          网络接口：1个，RJ45 10M/100M/1000M/自适应以 太网口<br>
          电源：DC 12V 18W（外接适配器）<br>
          功耗：（不含硬 盘） ≤10W<br>
          工作温度:-10℃  ~+ 55℃<br>
          工作湿度:工作：10%～90%RH（无结冰、无凝露），   储藏：5%～90%RH（无结冰、无凝露）<br>
        </p>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header'
import Footer from '@/components/footer/Footer'
export default {
  name: 'Product1',
  data: function () {
    return {
      showStatus: false,
      colorType: '3',
      pageType: 'product',
      productType: 1,
      active: 1
    }
  },
  components: {
    Header,
    Footer
  },
  methods: {
    link() {
      this.$router.push('/Product1')
    },
    changeImg(active) {
      this.active=active
    },
    add (max) {
      if (this.active>=max) {
        this.active=1
      } else {
        this.active++
      }
    },
    reduce (max) {
      if (this.active<=1) {
        this.active=max
      } else {
        this.active--
      }
    },
  },
  mounted: function () {
    this.showStatus = true
  }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}
.header{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}
.content{
  margin: 0 auto;
  margin-top: 160px;
  width: 1000px;
}

.top {
  width: 100%;
  display: flex;
  margin-top: 20px;
}
.top_left {
  width: 320px;
  margin-right: 50px;
}
.img_big {
  width: 320px;
  height: 320px;
}
.img_box {
  width: 320px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}
.img_box .img_icon_box {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #eee;
  border-radius: 3px;
  width: 20px;
  height: 50px;
}
.img_icon_box .img_icon {
  width: 10px;
  cursor: pointer;
}
.img_small_box {
  flex: 1;
  display: flex;
  overflow: auto;
}
.img_small {
  width: 50px;
  height: 50px;
  object-fit: cover;
  margin: 0 10px;
  border-radius: 5px;
  cursor: pointer;
}
.img_small_active {
  border: 1px #333 solid;
}

.top_right {
  flex: 1;
  text-align: left;
  color: #333;
}
.top_right h3 {
  font-size: 24px;
}
.top_right h4 {
  font-size: 18px;
  margin: 10px 0;
}
.top_right h5 {
  font-size: 28px;
  margin: 20px 0;
  margin-bottom: 30px;
  color: red;
}
.top_right h5  span {
  font-size: 18px;
}
.top_right .link {
  color: #409EFF;
  margin-top: 30px;
  cursor: pointer;
}

.introduce {
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  color: #333;
  text-align: left;
}
.introduce h3 {
  font-weight: bolder;
  font-size: 20px;
  margin-bottom: 20px;
}
.introduce p {
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/product/product2.vue